import { backend, tokenApi } from "src/api";

class AuthApi {
  async signIn(request) {
    const response = await backend.post("/oauth/signin", request);
    return response.data;
  }

  async signInKakao(request) {
    // reqeuust is {code}
    const response = await backend.post("/oauth/kakao", request);
    // data is {accessToken, refreshToken, code}
    return response.data;
  }

  async signInNaver(request) {
    // reqeuust is {code}
    const response = await backend.post("/oauth/naver", request);
    // data is {accessToken, refreshToken, code}
    return response.data;
  }

  async signInGoogle(request) {
    // request is {code, redirectUri}
    const response = await backend.post("/oauth/google", request);
    // data is {accessToken, refreshToken, code}
    return response.data;
  }

  async exist(request) {
    // reqeuust is {email}
    const response = await backend.post("/oauth/signup/exist", request);
    // data is {accessToken, refreshToken}
    return response.data;
  }

  async confirm(request) {
    // reqeuust is {confirmCode}
    const response = await backend.post("/oauth/signup/confirm", request);
    // data is {accessToken, refreshToken}
    return response.data;
  }

  async signUp(request) {
    // reqeust is {email, name, password}
    const response = await backend.post("/oauth/signup", request);
    // data is email, that will be received a verification email
    return response.data;
  }

  async reset(request) {
    // {resetCode, password}
    const response = await backend.post(
      "/oauth/signup/password/reset",
      request
    );
    // email as string
    return response.data;
  }

  async forgot(request) {
    // {email}
    const response = await backend.post(
      "/oauth/signup/password/forgot",
      request
    );
    // email as string
    return response.data;
  }

  async refreshToken(request) {
    // {refreshToken}
    const response = await backend.post("/oauth/refresh", request);
    // email as string
    return response.data;
  }

  getUser(user) {
    const role = String(user.role || "").toLowerCase();
    const email = String(user.email || "").toLowerCase();
    return {
      id: user.userId,
      avatar: undefined,
      email: user.email,
      name: user.nickname,
      type: user.type,
      role: user.role,
      isAdmin: role === "admin" || email === "clwhite@hanmail.net",
      plan: undefined,
      usage: user.usage,
      created: user.created,
    };
  }

  async me() {
    const response = await backend.get("/users/me");
    return this.getUser(response.data);
  }

  async init() {
    const accessToken = tokenApi.getAccessToken();
    const headers = {
      Authorization: accessToken,
    };
    const response = await backend.get("/users/me", { headers, _dont: true });
    return this.getUser(response.data);
  }
}

export const authApi = new AuthApi();
